export enum Category {
  CUSTOMER = "customer",
  PATIENT = "patient",
  PRESENTATION = "presentation",
  DIAGNOSIS = "diagnosis",
  ORGANS = "organs",
  DIET = "diet",
  ALLERGIES = "allergies",
  INSURANCE_NUMBERS = "insuranceNumbers",
  REFERRING_PHYSICIANS = "referringPhysicians",
  COLORS_DOG = "colors-dog",
  MARKETING = "marketing",
  ACTIVE_SUBSTANCE = "active-substance",
  PROFIT_CENTER = "profit-center",
  STUDIES = "studies",
  WARD = "ward"
}

export interface Tag {
  id: string;
  name: string;
  category?: string;
  color?: string;
  createdAt: string;
  deleted?: boolean;
}

export type TagCreate = Omit<Tag, "id" | "number" | "createdAt">;

export type TagUpdate = Omit<Tag, "id" | "number" | "createdAt">;

export type TagLight = Pick<
  Tag,
  "id" | "name" | "category" | "color" | "deleted"
>;
